import { legacy_createStore as createStore, compose } from "redux";
import reducers from "./reducers";

//add react dev tools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducers, composeEnhancers());

export default store;
